// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { mergeListings } from './mergeListings';
import { mapFiltersFields } from './mapFiltersFields';
import { mapMetaInfo } from './mapMetaInfo';
import { mapAdTargeting } from './mapAdTargeting';

const ONE_BASED_INDEX_OFFSET = 1;
const INLINE_FEATURED_LIST_OFFSET = 4;

const featuredTypeToVariant = {
    featured: 'Featured',
    weekly_featured: 'Weekly Featured'
};

const getFeaturedImpressionVariant = (
    featuredType: string | null | undefined
): string =>
    featuredTypeToVariant[featuredType] ?? featuredTypeToVariant.featured;

function rebuildAnalyticsEcommerce(analyticsEcommerce, featuredListings): void {
    if (analyticsEcommerce) {
        const list = analyticsEcommerce.impressions[0]?.list ?? '';
        const featuredImpressions = featuredListings.map(
            (featuredListing, index) => ({
                id: Number(featuredListing.listingId),
                list,
                position: index + ONE_BASED_INDEX_OFFSET,
                variant: getFeaturedImpressionVariant(
                    featuredListing.featuredType
                )
            })
        );
        const updatedImpressions = analyticsEcommerce.impressions.map(
            (impression, index) => ({
                ...impression,
                // Note: There are always three featured listing slots if at least one featured property is present. Hence add four
                // to the position of standard/premium listings if this is the case, else just add one (as positions are one based indexed)
                position:
                    index +
                    (featuredListings.length > 0
                        ? INLINE_FEATURED_LIST_OFFSET
                        : ONE_BASED_INDEX_OFFSET)
            })
        );

        analyticsEcommerce.impressions.splice(
            0,
            analyticsEcommerce.impressions.length,
            ...[...featuredImpressions, ...updatedImpressions]
        );
    }
}

export function dtoMapper(listingsDTO) {
    const sortOrderFields = listingsDTO?.sortOrder?.formConfig?.fields[0];
    const userAlertIdField = listingsDTO?.sortOrder?.formConfig?.fields.find(
        (f) => f.name === 'user_alert_id'
    );
    const { formConfig, ...paginationRest } = listingsDTO.pagination;
    const polyenc = formConfig?.fields?.find((f) => f.name === 'polyenc');

    // Add featured properties to the analyticsEcommerce array
    const featuredListings = mergeListings(listingsDTO, 'listingsFeatured');
    rebuildAnalyticsEcommerce(listingsDTO.analyticsEcommerce, featuredListings);

    try {
        return {
            ...listingsDTO,
            filters: mapFiltersFields(listingsDTO),
            metaInfo: mapMetaInfo(listingsDTO),
            pagination: {
                ...paginationRest,
                totalResults: listingsDTO.results.totalResults,
                totalResultsWasLimited:
                    listingsDTO.results.totalResultsWasLimited
            },
            links: {
                saveSearch:
                    listingsDTO?.saveAndAlerts?.saveSearchLink?.uri || '',
                createAlert:
                    listingsDTO?.saveAndAlerts?.createAlertLink?.uri || '',
                mapView: listingsDTO?.listingSearchUris?.mapViewUri || ''
            },
            listings: {
                regular: mergeListings(listingsDTO, 'listings'),
                featured: featuredListings,
                extended: mergeListings(listingsDTO, 'listingsExtended')
            },
            sortOrder: {
                currentSortOrder:
                    listingsDTO?.sortOrder?.currentSortOrder?.value,
                options: sortOrderFields?.fieldset?.fields?.[0]?.options?.map(
                    (o) => ({
                        i18NLabelKey: o.i18NLabelKey,
                        value: o.value
                    })
                )
            },
            seoBlurb: listingsDTO.seoBlurb,
            title: listingsDTO?.results?.title,
            adTargeting: mapAdTargeting(listingsDTO),
            userAlertId: userAlertIdField ? userAlertIdField.value : null,
            savedSearchAndAlerts:
                listingsDTO?.saveAndAlerts?.alertAndSaveSearchLink || null,
            polyenc: polyenc ? polyenc.value : null
        };
    } catch (e) {
        return {};
    }
}
